<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <Question4in1 :data="data" @jump="jump" @finish="finish"></Question4in1>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';

import Question4in1 from '../../cmp/question4in1';

export default {
  data() {
    return {
      data: {
        headTipImg: '苏尚卿讲解',
        headTipTxt: '没关系，我们去下个地方看看吧',
        headTipPathTxt: '前往绛雪轩 >>',
        headTipPath: '/rodemap/ssq/03',

        sideImg: '贵妃',
        qText: '我的狗丢了，你们能帮我找一下吗？',
        errText: '不是它呢，麻烦你们啦，我再自己找找',
        okText: '我的狗丢了，你们能帮我找一下吗？',
        btnText: '就选它了',
        answerArr: [
          {
            img: '找狗选项1',
          },
          {
            img: '找狗选项2',
          },
          {
            img: '找狗选项3',
          },
          {
            img: '找狗选项4',
            right: true,
          },
        ],
      },
    };
  },
  components: {
    Question4in1,
  },
  created() {
    Global.pauseAll();
  },
  computed: {},
  methods: {
    jump(event) {
      if (event) {
      } else {
        this.$router.replace('/rodemap/ssq/03');
      }
      console.log(event, 'event');
    },
    finish(event) {
      if (event) {
        Global.startPlay('ssq', 'scene2');
        Global.curr = {
          ...this.data,
          headTipImg: '苏尚卿讲解',
          headTipTxt: '哇，真厉害呢，我们继续逛吧',
          headTipPath: '/rodemap/ssq/03',
          headTipPathTxt: '前往绛雪轩 >>',
          textCfg: {
            'text-align': 'center',
          },
            headTipStyle: {
                bottom: '-1.5rem',
            },
          ybtxt: '就是它呢，谢谢你们啦，这个送给你们',
          bg: '琼苑东门',
        };
        Global.yubi.ssq.b1 = true;
        this.$router.replace('/yu');
      } else {
        Global.startPlay('ssq', 'scene3');
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/琼苑东门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
